// Your firebase Settings
export default {
  // PRO
  apiKey: process.env.VUE_APP_apiKey,
  authDomain: process.env.VUE_APP_authDomain,
  databaseURL: process.env.VUE_APP_databaseURL,
  projectId: process.env.VUE_APP_projectId,
  storageBucket: process.env.VUE_APP_storageBucket,
  messagingSenderId: process.env.VUE_APP_messagingSenderId

  // PRE
  // apiKey: 'AIzaSyB_Jig1MBqiwQ3mM1o_JpcCETye74_Jg-Y',
  // authDomain: 'boncarbon-pre.firebaseapp.com',
  // databaseURL: 'https://boncarbon-pre.firebaseio.com',
  // projectId: 'boncarbon-pre',
  // storageBucket: 'boncarbon-pre.appspot.com',
  // messagingSenderId: '790815226395',
  // appId: '1:790815226395:web:e736f770c5fbe9dd'
}
